module.exports = __webpack_public_path__ + "assets/car.917a2bb6d2fb726f80a2f1d199cdecb4.png";